<template>
	<div>
		<div style="width: 80%; margin: 0 10%;">
			<div class="inner-content">
				<video id="myVideo" class="video-box video-js">

				</video>
			</div>
			<div class="back">
				<div class="back-button" @click="$router.back(-1)">
					返回列表
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				videoUrl: '',
				details: {}
			}
		},
		mounted() {
			let that = this
			that.videoUrl = that.$imgUrl + that.$route.query.video_id
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/cgfw_top.png'
			that.initVideo()
		},
		methods: {
			backToList() {
				this.router.back(-1)
			},
			initVideo() {
				let myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: true,
					//设置视频播放器的显示宽度（以像素为单位）
					width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					height: "400px",
					sources: [{ // 播放资源和资源格式
						type: "video/mp4",
						src: this.videoUrl //你的视频地址（先为空，之后动态赋值）
					}],
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.news-xinxi {
		width: 100%;
		height: 70px;
		line-height: 70px;
		display: flex;
		color: #686868;
		font-size: 11px;
	}
	.details {
		color: #333333;
		font-size: 12px;
		margin-top: 20px;
		text-align: left;
	}
	.details-img {
		width: 100%;
		margin: 20px 0;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.video-box {
		width: 100%;
		height: 500px;
		margin: 10px 0;
	}
	.back {
		position: relative;
		margin: 30px 0;
		height: 20px;
		.back-button {
			position: absolute;
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			right: 28px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/video_player/video_player.vue